module.exports = __webpack_public_path__ + "img/live-stream-badge.01a5cd05.svg";